<script setup>
import { useI18n } from '../../i18n.js'
import { computed, ref } from 'vue'
import Pts2FilterChip from './Pts2FilterChip.vue'

const { t } = useI18n()

const model = defineModel({ type: Array, required: true })
const props = defineProps({
  label: { type: String, required: true },
  options: { type: Array, default: () => [] },
  placeholder: { type: String, required: true },
  disabled: { type: Boolean, default: false },
  appearance: { type: String, default: 'neutral' },
  optionLabel: { type: Function, required: true },
})

const menu = ref(null)
const selectedOptions = computed(() => model.value.map((number) => ({
  number,
  option: props.options.find((item) => item.number === number) ?? { number, name: null },
})))

function toggle(number) {
  model.value = model.value.includes(number)
    ? model.value.filter((value) => value !== number)
    : [...model.value, number]
}

function closeMenu() {
  if (!menu.value?.open) return
  menu.value.open = false
  menu.value.querySelector('summary')?.focus()
}
</script>

<template>
  <fieldset class="pts2-checklist-filter">
    <legend>{{ label }}</legend>
    <div class="pts2-checklist-control">
      <div class="pts2-checklist-values">
        <Pts2FilterChip v-for="selected in selectedOptions" :key="selected.number"
          :entity-id="appearance === 'entity' ? selected.number : null"
          :appearance="appearance" :label="optionLabel(selected.option)" @remove="toggle(selected.number)" />
        <span v-if="!selectedOptions.length" class="pts2-filter-placeholder">{{ placeholder }}</span>
      </div>
      <details ref="menu" class="pts2-checklist-menu" :class="{ disabled }" @keydown.esc.stop.prevent="closeMenu">
        <summary role="button" :aria-label="t('pts2UiHistoryChooseLabel', { label })" :aria-disabled="disabled"
          @click="disabled && $event.preventDefault()">{{ t('pts2UiHistoryChoose') }}</summary>
        <div>
          <label v-for="option in options" :key="option.number">
            <input type="checkbox" :checked="model.includes(option.number)" :disabled="disabled"
              @change="toggle(option.number)">
            {{ optionLabel(option) }}
          </label>
          <span v-if="!options.length" class="pts2-checklist-empty">{{ t('pts2UiHistoryNoOptions') }}</span>
        </div>
      </details>
    </div>
  </fieldset>
</template>
